import { useImageSearch } from "../hooks/useImageSearch"

interface Props {
  initialQuery: string
  onSelect: (url: string) => void
  onClose: () => void
}

export default function ImagePicker({
  initialQuery,
  onSelect,
  onClose,
}: Props) {
  const {
    query,
    changeQuery,
    results,
    status,
    search,
    hideBrokenImage,
    hasMore,
    showMore,
  } = useImageSearch(initialQuery)
  return (
    <section
      aria-label="Find a picture"
      className="border rounded-lg p-3 space-y-3"
    >
      <label className="block text-sm">
        Picture search
        <input
          value={query}
          maxLength={400}
          onChange={(event) => {
            changeQuery(event.target.value)
          }}
          onKeyDown={(event) => {
            if (event.key === "Enter") {
              event.preventDefault()
              void search()
            }
          }}
          className="w-full border rounded-lg px-3 py-2"
        />
      </label>
      <div className="flex flex-wrap gap-3">
        <button
          type="button"
          onClick={() => void search()}
          className="min-h-11 min-w-11 px-3 text-blue-600"
        >
          Search
        </button>
        <button type="button" className="min-h-11 px-3" onClick={onClose}>
          Close picture search
        </button>
      </div>
      <p role="status" className="text-sm">
        {status}
      </p>
      <div className="grid grid-cols-2 sm:grid-cols-3 gap-3">
        {results.map((result, index) => (
          <div key={result.image_url}>
            <button
              type="button"
              aria-label={`Use ${result.title || `picture ${index + 1}`}`}
              onClick={() => onSelect(result.image_url)}
              className="w-full rounded border p-1 focus:ring-2 focus:ring-blue-500"
            >
              <img
                src={result.thumbnail_url}
                alt={result.title}
                loading="lazy"
                referrerPolicy="no-referrer"
                onError={() => {
                  hideBrokenImage(result.image_url)
                }}
                className="w-full h-28 object-contain"
              />
            </button>
            {result.source_url && (
              <a
                href={result.source_url}
                target="_blank"
                rel="noopener noreferrer"
                className="text-xs text-blue-600"
              >
                View source
              </a>
            )}
          </div>
        ))}
      </div>
      {hasMore && (
        <button type="button" onClick={showMore} className="min-h-11 min-w-11 px-3 text-blue-600">
          Show more
        </button>
      )}
      <a
        href="https://brave.com/search/api/"
        target="_blank"
        rel="noopener noreferrer"
        className="text-xs text-gray-500"
      >
        Powered by Brave Search
      </a>
    </section>
  )
}
